import { FileType } from '@/shared/graphql/router/graphql'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'

import type { MatchSide } from '../match/MatchCompareCard.vue'
import { findingFileType, findingTitle, type Finding } from './findings'
import { mediaFileType } from './report'
import type { CheckerResults } from './results'

export const checkedMaterial = (results: CheckerResults) => {
  if (results.source === 'audio')
    return {
      name: 'Recorded audio',
      fileType: FileType.Audio,
      type: fileTypeToThumbnail(FileType.Audio),
      src: undefined,
    }
  if (results.source === 'visual')
    return {
      name: 'Captured visual',
      fileType: FileType.Image,
      type: fileTypeToThumbnail(FileType.Image),
      src: results.frames[results.frames.length - 1],
    }
  const fileType = results.media
    ? mediaFileType(results.media)
    : FileType.Generic
  return {
    name: results.media?.name ?? 'Uploaded file',
    fileType,
    type: fileTypeToThumbnail(fileType),
    src: undefined,
  }
}

export const checkerWorks = (
  finding: Finding,
  results: CheckerResults
): { registered: MatchSide; infringing: MatchSide } => {
  const material = checkedMaterial(results)
  return {
    registered: { name: findingTitle(finding), type: findingFileType(finding) },
    infringing: {
      name: material.name,
      type: material.fileType,
      src: material.src,
    },
  }
}
